// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"815":"54d51faa","951":"92e0983d"}[chunkId] + ".chunk.js";
};